import instance from "./api";

export default {
  getSettings: async () => {
    return instance.get(`/settings`);
  },
  getSettingsMaxPoints: async () => {
    return instance.get(`/settings/max-points`)
  },
  saveSettings: async (data) => {
    return instance.put(`/settings`, data);
  },
};
